import httpClient from '../../api';
import { fetchInitSingle, fetchSingle } from '../store-common';

export default () => ({
  namespaced: true,

  state: () => ({
    vacancy: fetchInitSingle(),
  }),

  mutations: {
    setVacancy(state, payload) {
      state.vacancy = { ...payload };
    },
  },

  actions: {
    async fetchVacancy(context, id) {
      await fetchSingle(async () => {
        const data = await context.dispatch('fetchVacancyById', id);
        return data;
      }, context, 'setVacancy');
    },
    async fetchVacancyById(context, id) {
      const { data: { data } } = await httpClient.get(`/vacancies/${id}`);
      return data;
    },
    async fetchDemoVacancyByLocale(context, locale) {
      const { data: { data } } = await httpClient.get(`/vacancies/demo/${locale}`);
      return data;
    },
    async checkIfDemoVacancy(context, id) {
      const { data: { data } } = await httpClient.get(`/vacancies/demo/check/${id}`);
      return data;
    },
    async fetchTest(context, id) {
      const { data: { data } } = await httpClient.get(`/vacancies/${id}/public-test`);
      return data;
    },
    async fetchTestById(context, { vacancyId, testId }) {
      const { data: { data } } = await httpClient.get(`/vacancies/${vacancyId}/public-test/${testId}`);
      return data;
    },
  },
});
